// extracted by mini-css-extract-plugin
export default {"root":"AISearch-module__root___1aAxu"};